module.exports = __webpack_public_path__ + "img/history-arrow.82e0ae98.svg";